import { Link } from "react-router-dom";
import "./Header.css";
const Header = () => {
  return (
    <div className="navbar ">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-slate-600 rounded-box w-52"
          >
            <li className="nav_item">
              <Link to="/" className="nav_link .active-link">
                <i className="uil uil-home nav_icon"></i>Home
              </Link>
            </li>
            <li className="nav_item">
              <Link to="/about" className="nav_link">
                <i className="uil uil-user nav_icon"></i>About
              </Link>
            </li>

            <li className="nav_item">
              <Link to="/skills" className="nav_link">
                <i className="uil uil-scenery nav_icon"></i>My Projects
              </Link>
            </li>
            <li className="nav_item">
              <Link to="/contact" className="nav_link">
                <i className="uil uil-scenery nav_icon"></i>Contact
              </Link>
            </li>
          </ul>
        </div>{" "}
        <Link to="/" className="nav_logo ml-32  underline">
          Sakib
        </Link>
      </div>
      <div className="navbar-center hidden  lg:flex">
        <ul className="menu menu-horizontal p-0">
          <li className="nav_item">
            <Link to="/" className="nav_link .active-link">
              <i className="uil uil-home nav_icon"></i>Home
            </Link>
          </li>
          <li className="nav_item">
            <Link to="/about" className="nav_link">
              <i className="uil uil-user nav_icon"></i>About
            </Link>
          </li>

          <li className="nav_item">
            <Link to="/skills" className="nav_link">
              <i className="uil uil-scenery nav_icon"></i>My Projects
            </Link>
          </li>
          <li className="nav_item">
            <Link to="/contact" className="nav_link">
              <i className="uil uil-scenery nav_icon"></i>Contact
            </Link>
          </li>
        </ul>
      </div>
      {/* <div className="navbar-end">
          <a className="btn">Get started</a>
        </div> */}
    </div>
  );
};

export default Header;
